import angular from "angular";

angular
    .module('app')
    .component('activeStudentsControl', {
        template: require('./active-students-control.html'),
        controller: ['$http', '$uibModal', 'ErrorResponseParser', 'Notifier', '$scope', controller],
        bindings: {}
    });

function controller($http, $uibModal, ErrorResponseParser, Notifier, $scope) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = '20';

    $ctrl.search = null;
    $ctrl.currentStatus = null;
    $ctrl.student = null;

    $ctrl.orderBy = 'attached_at';
    $ctrl.orderDir = 'desc';

    $ctrl.total = 0;

    $ctrl.$onInit = function () {
        $ctrl.getStudentsList();
    };

    $ctrl.getStudentsList = function () {
        $http
            .get('/admin/active-groups-students/get-individual-students-list', {
                params: {
                    page: $ctrl.page,
                    per_page: $ctrl.perPage,
                    order_by: $ctrl.orderBy,
                    order_dir: $ctrl.orderDir,
                    search: $ctrl.search,
                    status: $ctrl.currentStatus,
                    student_id: $ctrl.student ? $ctrl.student.id : null,
                }
            })
            .then(
                function (response) {
                    $ctrl.students = response.data.data;
                    $ctrl.total = response.data.total;
                    console.log($ctrl.students);
                },
                function (error) {

                }
            );
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getStudentsList();
    }

    $ctrl.setOrderBy = function (orderBy) {
        if ($ctrl.orderBy == orderBy) {
            $ctrl.orderDir = $ctrl.orderDir == 'asc' ? 'desc' : 'asc';
        } else {
            $ctrl.orderBy = orderBy;
            $ctrl.orderDir = 'asc';
        }
        $ctrl.page = 1;
        $ctrl.getStudentsList();
    };
}
